import React from 'react'
import NavBar from '../components/navbar';
import logo from '../assets/logo.png';
import Hero from '../components/hero';
import heroImg1 from '../assets/hero1.jpeg';
import NewArrival from '../components/new_arrival';
import Footer  from '../components/footer';
import { products,bannerImages } from '../constant'

export default function HomePage() {
  return (
    <div className='bg-white p-2 sm:p-1 '>
      <NavBar logo={logo} />
      <Hero images={[heroImg1,...bannerImages.map(b=> b.image)]} />
      <NewArrival title="Promotion" subTitle='Discount Items' products={products}/>
      <NewArrival title="Trending" subTitle='New Arrivals' products={products}/>
      <Footer/>
    </div>
  )
}
